/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Stock tooltip + variant availability + option UI sync
(function () {
  'use strict';

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function closestRoot(el) {
    return (el && el.closest && el.closest('.shopify-section, section, .product, .Product, .card')) || document;
  }

  function getProductData(root) {
    var el = (root && root.querySelector && root.querySelector('[data-product-json]')) || document.querySelector('[data-product-json]');
    if (!el) return null;

    try {
      return JSON.parse(el.textContent || el.innerText || '{}');
    } catch (e) {
      return null;
    }
  }

  function buildVariantMap(productData) {
    var variants = (productData && productData.product && productData.product.variants) || [];
    var map = {};
    variants.forEach(function (v) {
      map[String(v.id)] = v;
    });
    return map;
  }

  function getForm(root) {
    return (root && root.querySelector && (root.querySelector('form.product-form') || root.querySelector('form[action*="/cart/add"]'))) || document.querySelector('form[action*="/cart/add"]');
  }

  function getIdInput(form) {
    return form ? form.querySelector('[name="id"]') : null;
  }

  function swapAvailabilityByVariantId(variantId, root) {
    if (!variantId) return;

    var idStr = String(variantId);
    var tpl = (root && root.querySelector && root.querySelector('#AvailabilityVariant-' + idStr)) || document.getElementById('AvailabilityVariant-' + idStr);
    var container = (root && root.querySelector && root.querySelector('[data-availability-container]')) || document.querySelector('[data-availability-container]');
    if (!tpl || !container) return;

    container.innerHTML = tpl.innerHTML;

    document.querySelectorAll('.stock-tooltip-wrapper.active').forEach(function (w) {
      w.classList.remove('active');
    });
  }

  var syncing = false;

  function setOptionValue(root, position, value) {
    var v = String(value);

    // 1) data-option-position wrapper (yleisin näissä teemoissa)
    var wrapper = root.querySelector('[data-option-position="' + position + '"]');
    if (wrapper) {
      var select = wrapper.querySelector('select');
      if (select) {
        select.value = v;
        return true;
      }

      var radio = wrapper.querySelector('input[type="radio"][value="' + cssEscape(v) + '"]');
      if (radio) {
        radio.checked = true;
        return true;
      }
    }

    // 2) fallback: suorat name-mallit
    var select2 = root.querySelector('select[name="option' + position + '"], select[name="options[option' + position + ']"]');
    if (select2) {
      select2.value = v;
      return true;
    }

    var radio2 = root.querySelector(
      'input[type="radio"][name="option' + position + '"][value="' + cssEscape(v) + '"], ' +
        'input[type="radio"][name="options[option' + position + ']"][value="' + cssEscape(v) + '"]'
    );
    if (radio2) {
      radio2.checked = true;
      return true;
    }

    return false;
  }

  function syncOptionUI(root, variant) {
    if (!variant || syncing) return;
    syncing = true;

    var opts = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
    for (var i = 0; i < opts.length; i++) {
      setOptionValue(root, i + 1, opts[i]);
    }

    syncing = false;
  }

  function updateUrlVariant(variantId) {
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', String(variantId));
      window.history.replaceState({}, '', url.toString());
    } catch (e) {
      // ignore
    }
  }

  function applyVariantId(root, variantMap, variantId) {
    if (!variantId) return;

    var idStr = String(variantId);
    var v = variantMap[idStr];

    // 1) Saatavuus
    swapAvailabilityByVariantId(idStr, root);

    // 2) Option UI synkkaan aina oikeaan varianttiin
    if (v) syncOptionUI(root, v);

    // 3) URL synkkaan (ei pakollinen, mutta estää outoja reload-caseja)
    updateUrlVariant(idStr);
  }

  function initForRoot(root) {
    var data = getProductData(root);
    if (!data) return;

    var variantMap = buildVariantMap(data);
    var form = getForm(root);
    if (!form) return;

    var idInput = getIdInput(form);
    if (!idInput) return;

    function getInitialVariantId() {
      var urlId = new URLSearchParams(window.location.search).get('variant');
      return urlId || idInput.value || (data.selected_variant_id ? String(data.selected_variant_id) : '');
    }

    // Initial sync (URL variant > hidden input > theme selected)
    var initialId = getInitialVariantId();
    if (initialId && idInput.value !== String(initialId)) {
      idInput.value = String(initialId);
    }
    applyVariantId(root, variantMap, initialId);

    // Theme events (eri teemoissa voi olla eri event-nimi)
    function onVariantEvent(e) {
      if (!e || !e.detail || !e.detail.variant || !e.detail.variant.id) return;
      applyVariantId(root, variantMap, e.detail.variant.id);
    }

    document.addEventListener('variant:changed', onVariantEvent);
    document.addEventListener('variant:change', onVariantEvent);
    document.documentElement.addEventListener('variant:changed', onVariantEvent);
    document.documentElement.addEventListener('variant:change', onVariantEvent);

    // Catch-all: jos teema ei ammu eventtiä, luetaan id-inputin arvo option-muutoksen jälkeen
    var raf = null;
    function scheduleFromIdInput() {
      if (syncing) return;
      if (raf) cancelAnimationFrame(raf);

      raf = requestAnimationFrame(function () {
        raf = null;
        applyVariantId(root, variantMap, idInput.value);
      });
    }

    form.addEventListener('change', scheduleFromIdInput);
    form.addEventListener('input', scheduleFromIdInput);

    // MutationObserver (jos teema päivittää value-attribuuttia)
    try {
      var mo = new MutationObserver(scheduleFromIdInput);
      mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    } catch (e) {
      // ignore
    }
  }

  // Tooltip (delegated)
  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest && e.target.closest('.stock-tooltip-trigger');
    if (trigger) {
      e.preventDefault();

      var wrapper = trigger.closest('.stock-tooltip-wrapper');
      if (!wrapper) return;

      document.querySelectorAll('.stock-tooltip-wrapper.active').forEach(function (other) {
        if (other !== wrapper) other.classList.remove('active');
      });

      wrapper.classList.toggle('active');
      return;
    }

    if (!e.target.closest || !e.target.closest('.stock-tooltip-wrapper')) {
      document.querySelectorAll('.stock-tooltip-wrapper.active').forEach(function (w) {
        w.classList.remove('active');
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    var jsonEls = document.querySelectorAll('[data-product-json]');
    if (!jsonEls.length) {
      initForRoot(document);
      return;
    }

    jsonEls.forEach(function (el) {
      initForRoot(closestRoot(el));
    });
  });
})();

// Force initial variant to an IN-STOCK one (by Atom metafield availability templates), prefer same option1
(function () {
  function getProductData() {
    var el = document.querySelector('[data-product-json]');
    if (!el) return null;

    try {
      var parsed = JSON.parse(el.textContent);
      return parsed && parsed.product ? parsed.product : null;
    } catch (e) {
      return null;
    }
  }

  function isVariantInStockByTemplate(variantId) {
    var tpl = document.getElementById('AvailabilityVariant-' + String(variantId));
    if (!tpl) return null; // unknown

    var html = tpl.innerHTML || '';

    // Teidän out-of-stock template sisältää nämä:
    // - class "out-of-stock"
    // - data-shipping-speed="out_of_stock"
    var isOut = html.indexOf('out-of-stock') !== -1 || html.indexOf('data-shipping-speed="out_of_stock"') !== -1;
    return !isOut;
  }

  function findVariantById(variants, id) {
    var idStr = String(id);
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === idStr) return variants[i];
    }
    return null;
  }

  function pickFallbackVariant(product, urlVariant) {
    var variants = product.variants || [];
    var option1 = urlVariant.option1;

    // 1) Ensisijaisesti: sama option1 (esim. Tactical -> Tactical)
    // Valitse ensimmäinen variantti joka on IN STOCK templatejen mukaan
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.option1 !== option1) continue;

      var ok = isVariantInStockByTemplate(v.id);
      if (ok === true) return v;
    }

    // 2) Jos samasta option1:stä ei löydy, hae mistä tahansa
    for (var j = 0; j < variants.length; j++) {
      var v2 = variants[j];
      var ok2 = isVariantInStockByTemplate(v2.id);
      if (ok2 === true) return v2;
    }

    return null;
  }

  function applyVariant(variant) {
    if (!variant) return;

    var form = document.querySelector('form.product-form');
    if (!form) return;

    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;

    // Päivitä hidden id
    idInput.value = variant.id;

    // Päivitä URL (ei reload)
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}

    // Ilmoita teemalle
    document.dispatchEvent(
      new CustomEvent('variant:changed', {
        bubbles: true,
        detail: { variant: variant }
      })
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Odota 1 frame, jotta AvailabilityVariant- templattet varmasti DOMissa
    requestAnimationFrame(function () {
      var product = getProductData();
      if (!product || !product.variants) return;

      var urlParams = new URLSearchParams(window.location.search);
      var urlVariantId = urlParams.get('variant');
      if (!urlVariantId) return;

      var urlVariant = findVariantById(product.variants, urlVariantId);
      if (!urlVariant) return;

      // Jos URL-variantti on teidän logiikalla IN STOCK, ei kosketa
      var urlOk = isVariantInStockByTemplate(urlVariant.id);
      if (urlOk === true) return;

      // Muuten fallback
      var fallback = pickFallbackVariant(product, urlVariant);
      applyVariant(fallback);
    });
  });
})();
